export default __webpack_public_path__ + "static/media/cover.94d20057.png";